import { render, staticRenderFns } from "./download.vue?vue&type=template&id=8a621766&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=8a621766&prod&lang=scss"
import style1 from "./download.vue?vue&type=style&index=1&id=8a621766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a621766",
  null
  
)

export default component.exports